import type { PlatformComponentProps } from "@b2bportal/core-types";
import {
  AvailabilityPage,
  useAvailabilityPage,
  useAvailabilityPageRoute,
} from "@tenant/hotels";

export const AvailabilityPageRoute = ({
  className,
  children,
}: PlatformComponentProps) => {
  const params = useAvailabilityPageRoute();

  const data = useAvailabilityPage({ ...params });
  return (
    <AvailabilityPage {...data} className={className}>
      {children}
    </AvailabilityPage>
  );
};
